import { setADDRESPONSESTATUS } from "../constants/addResponseStatus.types";

export const setAddResponseStatus = (status: string) => {
  return {
    type: setADDRESPONSESTATUS,
    payload: status,
  };
};
